import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import ErrorToolTipView from 'views/utils/ErrorToolTipView';
import ElapsedTimeView from 'views/utils/ElapsedTimeView';
import viewerSocialProfile from 'models/user/ViewerSocialProfile';
import UserSettings from 'models/user/UserSettings';
import templateHtml from 'templates/user/UserExperienceSetupView.html';
import ViewerUserPreferences from 'models/user/ViewerUserPreferences';
import LocaleMapper from 'utils/LocaleMapper';
import ToolTipUtil from 'utils/ToolTipUtil';
import DiveUtil from 'utils/diving/DiveUtil';
import { gcApi } from 'config/axios';

var Events = {
    ON_EXPERIENCES_SAVED: 'ON_EXPERIENCES_SAVED',
    ON_SWITCHES_CHANGE: 'ON_SWITCHES_CHANGE'
};

var UserExperienceDialogView = Backbone.View.extend({
    template: _.template(templateHtml),

    propertyFiles: ['/common/common', '/main_container/main_container'],

    initialize: function(args) {
        var saveEvent = args.saveEvent;
        this.marinePref = args.marinePref;
        this.userSettings = new UserSettings();
        this.userSettings.isReady = true; //We do not need to sync the model so we can set isReady to true immediately after initialization

        if (saveEvent) {
            this.on(saveEvent, this.onCreateDashboardClicked);
        }
    },

    render: function() {
        var locale = LocaleMapper.getFullLocale(ViewerUserPreferences.getLocale());
        this.$el.html(
            this.template({
                Localizer: Localizer,
                locale: locale,
                // temporary allow only users with the MB TESTER role to see the Marine experience option
                isMarineExperienceAvailable: this.isMarineExperienceAvailable()
            })
        );

        this.fitnessSwitch = this.$('#button-experience-fitness');
        this.fitnessSwitch.on('change', this.onSwitchToggled.bind(this));

        this.wellnessSwitch = this.$('#button-experience-wellness');
        this.wellnessSwitch.on('change', this.onSwitchToggled.bind(this));

        this.golfSwitch = this.$('#button-experience-golf');
        this.golfSwitch.on('change', this.onSwitchToggled.bind(this));

        this.diveSwitch = this.$('#button-experience-dive');
        this.diveSwitch.on('change', this.onDiveSwitchToggled.bind(this));

        this.marineSwitch = this.$('#button-experience-marine');
        this.marineSwitch.on('change', this.onSwitchToggled.bind(this));

        this.updateSelections();
        this.setupExternalBottomTimeView();
        ToolTipUtil.renderTooltips.call(this);
    },

    onCreateDashboardClicked: function(saveButton) {
        var selectedExperiences = this.getSelectedExperiences();
        if (this.userSetupIsValid()) {
            $(saveButton).attr('disabled', 'disabled');
            if (_.contains(selectedExperiences, 'ROLE_DIVE_USER')) {
                this.userSettings.setExternalBottomTime(this.externalBottomTimeView.calculateTime());
                this.userSettings.save({});
            }
            this.saveExperiences(selectedExperiences);
        }
    },

    userSetupIsValid: function() {
        var selectedExperiences = this.getSelectedExperiences();
        var visibleTooltips = this.$('.error-tooltip-active');
        return visibleTooltips.length === 0 && selectedExperiences.length > 0;
    },

    getSelectedExperiences: function() {
        var selectedExperiences = [];

        if (this.fitnessSwitch.is(':checked')) {
            selectedExperiences.push('ROLE_FITNESS_USER');
        }

        if (this.wellnessSwitch.is(':checked')) {
            selectedExperiences.push('ROLE_WELLNESS_USER');
        }

        if (this.golfSwitch.is(':checked')) {
            selectedExperiences.push('ROLE_OUTDOOR_USER');
        }

        if (this.diveSwitch.is(':checked')) {
            selectedExperiences.push('ROLE_DIVE_USER');
        }

        if (this.marineSwitch.is(':checked')) {
            selectedExperiences.push('ROLE_MARINE_USER');
        }

        return selectedExperiences;
    },

    saveExperiences: function(experiences) {
        var that = this;
        jQuery.ajax({
            url: '/modern/proxy/dashboard-service/userExperience',
            type: 'POST',
            data: JSON.stringify(experiences),
            contentType: 'application/json; charset=utf-8',
            success: function() {
                that.refreshUserSession(experiences);
            }
        });
    },

    // TODO: This works as a replacement for saveExperiences() but when calling the endpoint w/o /modern/proxy/ the roles don't persist
    // > this might have to do with a call in modern to the same endpoint but needs to be investigated further in CA-130289
    // saveExperiences: function(experiences) {
    //     const that = this;

    //     gcApi.post('/dashboard-service/userExperience', experiences)
    //     .then(() => {
    //         that.refreshUserSession(experiences);
    //     });
    // },

    refreshUserSession: function(experiences) {
        jQuery.post('/modern/refreshUserSession').always(
            function() {
                var roles = viewerSocialProfile.get('userRoles');
                viewerSocialProfile.set('userRoles', _.union(roles, experiences));
                this.handleSideBarComponents();
                this.trigger(Events.ON_EXPERIENCES_SAVED);
                this.trigger('ON_CLOSE');
            }.bind(this)
        );
    },

    /**
     * Called anytime any of the switches are toggled. Verifies that at
     * least one item has been switched on.
     */
    onSwitchToggled: function(e) {
        if (
            !this.golfSwitch.is(':checked') &&
            !this.fitnessSwitch.is(':checked') &&
            !this.wellnessSwitch.is(':checked') &&
            !this.marineSwitch.is(':checked') &&
            !this.diveSwitch.is(':checked')
        ) {
            this.errorToolTipView = new ErrorToolTipView({
                el: jQuery(e.target).closest('.connect-checkbox'),
                content: Localizer.localize('userexperience.dialog.no.activity.selected')
            });

            this.errorToolTipView.render();
            this.errorToolTipView.show();
        } else if (this.errorToolTipView) {
            this.errorToolTipView.hide();
            this.errorToolTipView = null;
        }

        this.trigger(Events.ON_SWITCHES_CHANGE, this.getSelectedExperiences().length);
        this.updateSelections();
    },

    /**
     * Handler to be called when Dive checkbox is checked
     * It toggles the display of external bottom time input
     */
    onDiveSwitchToggled: function(e) {
        if (this.diveSwitch.is(':checked')) {
            this.$('#externalBottomTime').show();
            this.externalBottomTimeView.validator.validateInputNow();
        } else {
            this.$('#externalBottomTime').hide();
            this.externalBottomTimeView.validator.clearReport();
        }
        this.onSwitchToggled(e);
    },

    setupExternalBottomTimeView: function() {
        this.externalBottomTimeView = new ElapsedTimeView({
            el: this.$('.externalBottomTimePlaceholder'),
            idPrefix: 'externalBottomTime_' + new Date().getTime(),
            hideSeconds: true,
            hourInputMaxLength: 3,
            maxTime: DiveUtil.maxSecondsOfBottomTime,
            maxExceededErrorKey: this.getExternalBottomTimeErrorKey
        });
        this.externalBottomTimeView.render();
    },

    getExternalBottomTimeErrorKey: function() {
        return Localizer.localize('user_experience_enter_a_time_less_than', DiveUtil.maxHoursOfBottomTime);
    },

    updateSelections: function() {
        if (this.fitnessSwitch.is(':checked')) {
            this.$('.fitness-experience-container').removeClass('disabled');
        } else {
            this.$('.fitness-experience-container').addClass('disabled');
        }

        if (this.wellnessSwitch.is(':checked')) {
            this.$('.wellness-experience-container').removeClass('disabled');
        } else {
            this.$('.wellness-experience-container').addClass('disabled');
        }

        if (this.golfSwitch.is(':checked')) {
            this.$('.golf-experience-container').removeClass('disabled');
        } else {
            this.$('.golf-experience-container').addClass('disabled');
        }

        if (this.diveSwitch.is(':checked')) {
            this.$('.dive-experience-container').removeClass('disabled');
        } else {
            this.$('.dive-experience-container').addClass('disabled');
        }

        if (this.marineSwitch.is(':checked')) {
            this.$('.marine-experience-container').removeClass('disabled');
        } else {
            this.$('.marine-experience-container').addClass('disabled');
        }
    },

    handleSideBarComponents: function() {
        var roles = viewerSocialProfile.get('userRoles');
        if (roles.length === 1 && roles.indexOf('ROLE_MARINE_USER') !== -1) {
            return;
        }

        if (
            roles.length === 3 &&
            roles.indexOf('ROLE_CONNECTUSER') !== -1 &&
            roles.indexOf('ROLE_CONNECT_2_USER') !== -1 &&
            roles.indexOf('ROLE_MARINE_USER') !== -1
        ) {
            return;
        }

        // Not Marine only user
        jQuery('.new-user').show();
    },

    isMarineExperienceAvailable: function() {
        return (
            viewerSocialProfile.get('userRoles').indexOf('ROLE_MBTESTER') > -1 ||
            this.marinePref.get('value') === 'true'
        );
    }
});

UserExperienceDialogView.Events = Events;

export default UserExperienceDialogView;
